// @flow

import { IFRAME_SUBSCRIBER_ID } from '../../common/iframeParameters'

import { getQuery } from '../../common'

export function getSubscriberIdFromQuery (): string {
  // $FlowFixMe
  return getQuery(IFRAME_SUBSCRIBER_ID)
}
